// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { formValueSelector, hasSubmitSucceeded } from 'redux-form';
import connectWithFormName from 'app/hoc/withFormName';
import { password, userName, captcha } from 'app/default/field/name';
import {getUrlParameter} from '../helpers/url';

const noop = () => {};

class Login extends React.Component<*> {
    formRef = null;

    componentDidUpdate() {
        const { login, password, registrationCompleted } = this.props;
        
        if (login && password && registrationCompleted) {
            this.submitForm();
        }
    }
    
    submitForm = () => {
        if (this.formRef) {
            this.formRef.submit();
        }
    };
    
    handleFormRef = (ref: *) => this.formRef = ref;

    render() {
        const { login, password, registrationCompleted, captcha } = this.props;
        
        if (login && password && registrationCompleted) {
            sessionStorage.removeItem('merchantId');

            const prospectSignupToken = getUrlParameter('prospect_signup_token');

            return (
                <form
                    action={`${this.props.signUpCompleteUrl || window.Config.url.signUpComplete}/login`}
                    ref={this.handleFormRef}
                    method="POST"
                    style={{display: 'none'}}
                >
                    <input type="text" name='username' value={login} onChange={noop}/>
                    <input type="password" name="password" value={password} onChange={noop}/>
                    <input type="hidden" name='is_signup' value="1" onChange={noop}/>
                    <input type="hidden" name='g-recaptcha-response' value={captcha} onChange={noop}/>
                    <input type="hidden" name='prospect_signup_token' value={prospectSignupToken} onChange={noop}/>
                </form>
            );
        }
        
        return false;
    }
}

Login.propTypes = {
    signUpCompleteUrl: PropTypes.string,
    login: PropTypes.string,
    password: PropTypes.string,
    registrationCompleted: PropTypes.bool,
    captcha: PropTypes.string,
};

const ConnectedLogin = connectWithFormName(
    (state, { formName }) => ({
        login: formValueSelector(formName)(state, userName[0]),
        password: formValueSelector(formName)(state, password),
        registrationCompleted: hasSubmitSucceeded(formName)(state),
        captcha: formValueSelector(formName)(state, captcha)
    })
)(Login);

export {
    ConnectedLogin as default, Login
};
